module.exports = {
  // TODO: Figure out which fields are actually needed here then remove the rest from all properties
  gatsbyConfig: {
    property: 'rideboreal',
    copyrightTagline: 'Boreal Mountain Resort',
    siteName: 'Boreal Mountain Resort',
    siteUrl: 'https://www.rideboreal.com/',
    reCaptchaDBPropertyName: 'Boreal',
    reCaptchaPublicKey: '6LfiiYIUAAAAAEvSxGg7A_ZOQRemWMgGBoTr0Z5P',
    onetrustID: '01960356-963c-732c-8ac7-c0c42baf96b9',
    color: '#64CAC7',
    facebook: 'borealmtn',
    instagram: 'borealmtn',
    twitter: 'borealmtn',
    dynamicTypes: [
      'pressRelease',
      'event',
      'blog',
      'camp',
    ],
    ignore404Routes: [
      '/explore/community/all-blogs',
      '/explore/community/all-events',
    ],
  },
  // TODO: Good way of managing API keys per site, maybe use for formbucket and mailchimp?
  contentfulConfig: {
    spaceId: '38vc2unmqsq5',
    accessToken: 'D2b0ZG2uKbPvWdW38GS0y3_hQN9AxH-iJnKijjoI0cA',
  },
};
